// Define rbr constants

module.exports = {
  NOTIFICATIONS_DELETE_ROW: 'NOTIFICATIONS_DELETE_ROW',
  NOTIFICATIONS_DELETE_ALL: 'NOTIFICATIONS_DELETE_ALL',
  NOTIFICATIONS_ADD_NEW: 'NOTIFICATIONS_ADD_NEW',
  NOTIFICATIONS_FILTER: 'NOTIFICATIONS_FILTER',
  NOTIFICATIONS_REACTION_EMOJI: 'NOTIFICATIONS_REACTION_EMOJI',
  NOTIFICATIONS_LOAD_DATA: 'NOTIFICATIONS_LOAD_DATA'
};
